import React, { PureComponent } from "react";

import Media from "Common/Media";
import MediaFetching from "Common/MediaFetching";

import styles from "./MediaList.local.scss";
import classnames from "classnames";
//import _ from "i18n";

export default class MediaListComponent extends PureComponent {
  render() {
    const { fetching } = this.props;

    if (fetching) {
      return (
        <ul className={classnames(styles.list, "grid-x")}>
          {Array(12)
            .fill(1, 0, 12)
            .map(el => (
              <li
                className="cell smal-12 medium-4 large-2"
                key={`media-fetching-${Math.random() + Date.now()}`}
              >
                <MediaFetching />
              </li>
            ))}
        </ul>
      );
    }
    const { medias, forAlbum } = this.props;

    return (
      <ul className={classnames(styles.list, "grid-x")}>
        {medias.map(media => (
          <li
            key={`media-item-${media.id}`}
            className={"small-12 medium-4 large-2"}
          >
            <div
              className={classnames(
                styles.media,
                forAlbum ? styles.forAlbum : ""
              )}
            >
              <Media media={media} />
            </div>
          </li>
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/MediaList/MediaListComponent.js